import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Popover } from 'antd';

import styled from 'styled-components';
import { DEFAULT_MAP_NAMESPACE } from './constants';
import { getGlobalSettings, genarateRendererConfigs } from '../utils';
import ComponentsMap from '../ComponentsMap';
import Wait4Me from '../../../components/Wait4Me';
import { normalizeAlertScore } from '../../../util/normalization';
import { convertISOToDateFormat } from '../../../util/timezone';

import { isEmpty, map, result } from '../../../util/lodashlike';
const LoadingWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AlertHeaderPanel = styled.div`
  padding-top: 5px;
  padding-bottom: 12px;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
`;

const AlertTopPanelDetails = ({
  apiActions,
  settings,
  gsQuery,
  alertDetails,
  alertId,
  isLoading,
  error,
  alertHeader,
  mapNamespace = DEFAULT_MAP_NAMESPACE,
  alertMetaSuffix,
  showAlertStatus,
  alertMetaPrefix
}) => {
  const { widgetConfig, isVisible } =
    getGlobalSettings({ settings, gsQuery }) || {};

  if (!isVisible || isEmpty(widgetConfig)) return null;

  const [dataSource, setDataSource] = useState(null);
  const { getAMLSCommonAlertDetails } = apiActions;

  useEffect(() => {
    setDataSource(null);
    getAMLSCommonAlertDetails({ alertId });
  }, [alertId]);

  useEffect(() => {
    if (!isEmpty(alertDetails)) {
      setDataSource(
        genarateRendererConfigs({
          data: alertDetails,
          settings: widgetConfig,
          configs: result(ComponentsMap, mapNamespace) || {},
          doFlatten: true
        })
      );
    }
  }, [alertDetails]);

  const column = (Component, idx, rest) => {
    const itemValue =
      rest?.itemLabel == 'Alert Score'
        ? normalizeAlertScore(rest.itemValue)
        : rest.itemValue;
    return (
      <Col
        key={`alert_detail_column_${idx}`}
        style={{ overflow: 'hidden', maxWidth: '20em' }}>
        {Boolean(Component) && rest?.itemValue?.length > 20 ? (
          <Popover
            content={
              rest?.itemLabel === 'Alert Date'
                ? convertISOToDateFormat(itemValue)
                : itemValue
            }>
            <Component {...rest} itemValue={itemValue} />
          </Popover>
        ) : (
          <Component {...rest} itemValue={itemValue} />
        )}
      </Col>
    );
  };

  return (
    <>
      {isLoading && (
        <LoadingWrapper>
          <Wait4Me />
        </LoadingWrapper>
      )}
      {alertHeader && dataSource && (
        <AlertHeaderPanel>{alertHeader}</AlertHeaderPanel>
      )}
      {dataSource && (
        <Row gutter={[40, 20]} justify="start" wrap={false}>
          {map(
            dataSource,
            ({ component: Component, itemName, ...rest }, idx) =>
              Component &&
              (showAlertStatus
                ? itemName == 'alertStatus'
                  ? ''
                  : column(Component, idx, rest)
                : column(Component, idx, rest))
          )}
          {alertMetaSuffix && (
            <Col style={{ position: 'static' }}>
              <Row wrap={false}> {alertMetaSuffix} </Row>
              {console.log('alertMetaSuffix', alertMetaSuffix)}
            </Col>
          )}
        </Row>
      )}
      {error && null}
    </>
  );
};

AlertTopPanelDetails.propTypes = {
  apiActions: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  gsQuery: PropTypes.object.isRequired,
  alertDetails: PropTypes.object,
  alertId: PropTypes.string.isRequired,
  alertHeader: PropTypes.string,
  mapNamespace: PropTypes.string,
  isLoading: PropTypes.bool,
  error: PropTypes.object,
  alertMetaSuffix: PropTypes.element,
  alertMetaPrefix: PropTypes.element
};

export default AlertTopPanelDetails;
